export const API_URL = process.env.VUE_APP_API_URL;
export const BASE_URL = process.env.VUE_APP_BASE_URL;

export const TOKEN = "ATTENDANCE_TOKEN";

export const ERROR_FIELD = 2;
export const INITIAL_FIELD = 0;
export const SUCCESS_FIELD = 1;

export const FIELD_STATUS_BOOTSTRAP_BASE = {
    0: "",
    1: "is-valid",
    2: "is-invalid"
}

export const FIELD_STATUS_BASE = {
    0: "",
    1: "valid",
    2: "invalid"
}

export const FILE_EXTENSIONS = {
    image : ['apng', 'png', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'],
    video : ['mkv', 'flv', 'vob', 'ogg', 'drc', 'avi', 'wmv', 'avchd', 'flv', 'mp4'],
    excel : ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xml', 'xlam', 'xla', 'xlw', 'xlr'],
    word : ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx']
}

export const ERROR_MESSAGES = {
    required_fields: 'Please fill in required fields.'
}

export const MENU_LINKS = [
    {
        to: {name: 'attendancePage'},
        icon: ['fas', 'user-plus'],
        iconType: 'fs',
        title: 'Attendance'
    },
    {
        to: {name: 'attendanceSummaryPage'},
        icon: 'article',
        iconType: 'material',
        title: 'Attendance List'
    },
    {
        to: {name: 'overtimeApplicationPage'},
        icon: ['fas', 'business-time'],
        iconType: 'fs',
        title: 'Overtime Application'
    },
    {
        to: {name: 'leaveApplicationPage'},
        icon: ['fas', 'calendar-plus'],
        iconType: 'fs',
        title: 'Leave Application'
    },
    {
        to: {name: 'biometricsPage'},
        icon: ['fas', 'fingerprint'],
        iconType: 'fs',
        title: 'Biometrics'
    },
    {
        to: {name: 'passwordManagement'},
        icon: ['fas', 'fa-key'],
        iconType: 'fs',
        title: 'Password Management'
    },
]
